var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 11.4583L3.28425 14.8197C3.45535 18.4048 3.54091 20.1973 4.7488 21.2966C5.9567 22.3958 7.84079 22.3958 11.609 22.3958H13.391C17.1592 22.3958 19.0433 22.3958 20.2512 21.2966C21.4591 20.1973 21.5447 18.4048 21.7157 14.8197L21.875 11.4583",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96614 10.8782C4.73624 14.2442 8.72866 15.625 12.5003 15.625C16.272 15.625 20.2644 14.2442 22.0345 10.8782C22.8795 9.27142 22.2397 6.25 20.1587 6.25H4.84199C2.76098 6.25 2.12119 9.27142 2.96614 10.8782Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.4583H12.5094",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6664 6.24999L16.5744 5.92805C16.116 4.32383 15.8869 3.52173 15.3413 3.06294C14.7956 2.60416 14.0709 2.60416 12.6215 2.60416H12.3778C10.9284 2.60416 10.2037 2.60416 9.65811 3.06294C9.11251 3.52173 8.88333 4.32383 8.42499 5.92805L8.33301 6.24999",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseWhite);
export default __webpack_public_path__ + "static/media/briefcaseWhite.84ba19e13b2d56223b075a387f806533.svg";
export { ForwardRef as ReactComponent };